import { render, staticRenderFns } from "./Mc.vue?vue&type=template&id=1a89a942&scoped=true&"
import script from "./Mc.vue?vue&type=script&lang=js&"
export * from "./Mc.vue?vue&type=script&lang=js&"
import style1 from "./Mc.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a89a942",
  null
  
)

export default component.exports